module.exports = {
    "collectionLabel": `Sugestie`
};


//# sourceMappingURL=pl-PL.main.js.map
